@if(service.viewDroplistItems.length) {
<div class='finance-awards-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	<ng-container [ngSwitch]="selectedViewItem.uniqueId">
		<finance-awards-entrepreneur-view-part
			*ngSwitchCase="service.viewId.Entrepreneurs"></finance-awards-entrepreneur-view-part>
		<finance-awards-accelerator-view-part
			*ngSwitchCase="service.viewId.Accelerators"></finance-awards-accelerator-view-part>
		<finance-awards-trimester-view-part
			*ngSwitchCase="service.viewId.Trimesters"></finance-awards-trimester-view-part>
	</ng-container>
	}

</div>
}